import "react-app-polyfill/stable"; /** Support IE11 */
import "react-app-polyfill/ie11"; /** Support IE11 */
import "es6-object-assign"; /** Support IE11 - Assign Object */
import React from 'react';
import { lookup } from 'zipcodes';
import { map, find } from 'lodash';
import { stateNames } from '../src/const/stateList';
import { errorMessages } from "../src/ErrorConfig/errorConfig";

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validateNPI = (npi) => {
  const re = /^ ?[0-9]+ ?$/;
  return re.test(npi) && npi.trim().length === 10;
};

const setInputError = (field, { emptyValue, invalidNPI, invalidEmail }) => {
  let message = '';
  if (invalidEmail || invalidNPI) message = errorMessages.invalidFormat;
  if (emptyValue) message = errorMessages.requiredValueMissing;
  const requiredFieldHTML = `<div class="form__error">
                              <div class="form__error-message">
                                ${message}
                              </div>
                            </div>`;
  field.parentNode.insertAdjacentHTML('beforeend', requiredFieldHTML);
}

export const removeInputError = (field) => {
  const errorMessage = field.nextSibling.nextSibling;
  if (errorMessage) errorMessage.remove();
  return;
}

export const removeErrorsOnChange = (requiredFields) => {
  requiredFields.forEach((field) => {
    field.addEventListener('change', () => {
      removeInputError(field);
      field.classList.remove('error');
      setDisplay('.alert-container', 'none');
    })
  })
}

export const validateForm = (requiredFields, noErrorClass) => {
  let error = { isValid: true, type: null }
  requiredFields.forEach((field) => {
    removeInputError(field);
    const emptyValue = !field.value || field.value.trim() === '';
    const invalidEmail = field.type === 'email' && !validateEmail(field.value);
    const invalidNPI = field.id === 'User_npi' && !validateNPI(field.value);
    if (invalidEmail || invalidNPI || emptyValue) {
      if (!noErrorClass) field.classList.add('error');
      if (field.id === 'user_health_plan') {
        if (!noErrorClass) document.querySelector('#user_health_plan').parentElement
          .querySelector(".selected-options")?.classList.add("error")
      }
      if (!noErrorClass) setInputError(field, { emptyValue, invalidEmail, invalidNPI });
      return error = { isValid: false, type: field.type, npi: field.id === 'User_npi' }
    }

    if (!noErrorClass) field.classList.remove('error');
  });
  return error;
};

export const maskNumber = (e) => {
  var x = e.target.value
    .replace(/\D/g, '')
    .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  e.target.value = !x[2]
    ? x[1]
    : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
};

export const setLoading = (selector, value, defaultValue) => {
  const elem = document.querySelector(selector);
  if (value) {
    elem.value = 'Loading...'
    elem.innerText = 'Loading...';
    elem.classList.add("disabled");
  } else {
    elem.innerText = defaultValue;
    elem.classList.remove("disabled");
  }
};



const stateList = () => {
  const node = document.getElementById('state-list');
  if (node) {
    const stateData = JSON.parse(node.getAttribute('data'));
    return map(stateData, (item) => {
      const value = find(stateNames, { name: item[0] });
      return {
        label: item[0],
        value: item[1],
        prefix: value ? value.prefix : ''
      }
    })
  }
};

export const lookupZip = (e) => {
  const data = lookup(e.target.value);
  const zip = e.target.value;
  document.getElementById('user_zip').value = zip.substr(0, 5);

  if (data) {
    const stateValue = find(stateList(), { prefix: data.state });
    document.getElementById('user_city').value = data.city;
    document.getElementById('user_state').value = stateValue.value;
  }
};

export const setDisplay = (item, display) =>
  (document.querySelector(item).style.display = display);

export const triggerBackBtn = () => {
  if (!document.querySelector("#step1-view")) {
    const backHome = document.querySelector('.back');
    const backBtn = document.querySelector('.btn-back');

    if (backHome)
      backHome.addEventListener('click', () => window.location.replace('/'));
    if (backBtn) backBtn.addEventListener('click', () => window.history.length > 1 ? window.history.back() : window.location.replace('/'));
  }
};

triggerBackBtn();

export const getFormattedData = (locations, searchValues) => {
  const gdfIds = locations.map(location => location.gdfId);
  return { // formatedlocations
    npi: searchValues.npi,
    location_gdf_ids: [...gdfIds],
    location_name: searchValues.locationName
  };
}

export const sanitizeContent = (message, tag) => {
  if (message.includes(tag)) {
    const content = message.split(tag);
    return (<>
      {content.map((text, index) => (
        <React.Fragment key={index}>
          {text}
          {index !== content.length - 1 && <><br /><br /></>}
        </React.Fragment>
      ))}
    </>);
  }
  return message;
}

export const showTooltip = (selector) => {
  const tooltip = document.querySelector(selector);
  tooltip.style.visbility = 'visible';
  tooltip.style.opacity = '1';
};

export const hideTooltip = (selector) => {
  const tooltip = document.querySelector(selector);
  tooltip.style.visibility = 'hidden';
  tooltip.style.opacity = '0';
};

export const toBoolean = (value) => {
  return value && String(value).toLowerCase() === "true";
}

